import * as React from 'react'

import { SVGResponsive } from './common'

function Ages() {
  return (
    <SVGResponsive height={24} width={24}>
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M4 11h16v11H4z"
      />
      <path stroke="currentColor" strokeLinecap="round" strokeWidth="2" d="M2 22h20" />
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M7 11V8M7 4V3M12 11V7M12 3V2M17 11V8M17 4V3M5 15.5c1 0 .5 1.5 2 1.5s1-1.5 2.5-1.5 1 1.5 2.5 1.5 1-1.5 2.5-1.5 1 1.5 2.5 1.5 1-1.5 2-1.5"
      />
    </SVGResponsive>
  )
}

export default React.memo(Ages)
